import React from "react";
import CCTM_parse from "../../CCTM_parse";

/**
 * @name CCTM_subnav
 * @function
 * @extends React.Component
 * @exported true
 * @description This component processes and renders a sub-navigation structure dynamically.
 *              It extracts properties from the first child and passes structured data to the component.
 * @param {Object} props - Component properties.
 * @param {React.Component} props.component - The component to be rendered.
 * @param {Function} [props.postRender] - Optional function to modify the component before rendering.
 * @param {React.ReactNode} [props.children] - Children elements representing sub-navigation items.
 * @example
 * export default function CCTM_subnav(props) {
 *  return (
 *    <CCTM_subnav component={MyComponent} postRender={(comp, props) => modifyComponent(comp, props)}>
 *      <div>SubNav Content</div>
 *    </CCTM_subnav>
 *  );
 * }
 */

export default function CCTM_subnav(props) {
    
    // Extract the component from props
    let Component = props.component;

    // Parse the properties from the first child element
    let subNavProps = CCTM_parse.getProps(props?.children[0]); 
    
    // Structure the extracted properties into newProps
    let newProps = {
        id: subNavProps?.id,
        label: subNavProps?.label,
        asset_name: subNavProps.asset_name,
        "asset_custom-class":subNavProps["asset_custom-class"],
        datapoint: subNavProps?.datapoint,
        "custom-class": subNavProps["custom-class"]
    };
                 
    // If a postRender function is provided, use it to modify the component before rendering
    if (typeof props.postRender == "function") {
        let RenderComponent = props.postRender(props.component, props);
        return (
            <RenderComponent {...subNavProps} currentNode={props?.children[1]} data={newProps} />
        );
    }
    
    // Render the component with the extracted sub-navigation properties
    return (
        <Component {...subNavProps} currentNode={props?.children[1]} data={newProps} />
    );
}